// extracted by mini-css-extract-plugin
export default {"mapPaperStyled":"classes@desktop_mapPaperStyled__PJY3C"};